import React from "react"
import ReactDOM from "react-dom"
import Footer from "./footer-component"

export default class FooterModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<Footer {...self.modelJson} />, self.elem)
  }
}
